import axios from "axios";
import router from "@/router";
import { Notify, Dialog, Toast } from "vant";
import store from "../store";
import { getToken } from "@/utils/auth";
import Config from "@/config";
import { removeToken } from "@/utils/auth.js";
import { simpleUuid, getDepNameByDomain } from "@/utils/index";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: Config.timeout, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (getToken() && config.url.indexOf("cus/") < 0) {
      config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers["Content-Type"] = "application/json";
    config.headers["reqId"] = simpleUuid();
    config.headers["depName"] = getDepNameByDomain();
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const code = response.status;
    if (code < 200 || code > 300) {
      Notify({
        type: "danger",
        message: response.message,
      });
      return Promise.reject("error");
    } else {
      return response.data;
    }
  },
  (error) => {
    let code = 0;
    try {
      code = error.response.data.status;
    } catch (e) {
      if (error.toString().indexOf("Error: timeout") !== -1) {
        Notify({
          type: "danger",
          message: response.message,
        });
        return Promise.reject(error);
      }
      if (error.toString().indexOf("Error: Network Error") !== -1) {
        Notify({
          type: "danger",
          message: response.message,
        });
        return Promise.reject(error);
      }
    }
    if (code === 401) {
      Toast.clear();
      Dialog.confirm({
        title: "系统提示",
        message: "登陆已过期，请重新登陆",
        theme: "round-button",
      }).then(() => {
        removeToken();
        router.push({
          path: "/login",
        });
      });
    } else if (code === 403) {
      router.push({ path: "/401" });
    } else {
      const errorMsg = error.response.data.message;
      if (errorMsg !== undefined) {
        Notify({
          type: "danger",
          message: errorMsg,
          duration: 2500,
        });
      }
    }
    return Promise.reject(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js